var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message__text"},[_c('div',{staticClass:"message__content"},[_c('block-helper-icon'),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('chat.deleted-message')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }